import {
  getEmailOtp,
  getOtp,
  useAppSelector,
  useResendOTPMutation,
  useSendOTPMutation,
  useVerifyOTPMutation,
} from '@zonofi/zono-money-store';

export const useLoginScreen = () => {
  const emailOtp = useAppSelector(getEmailOtp);
  const mobileOtp = useAppSelector(getOtp);

  const [sendOTPApiReq, sendOTPApiRes] = useSendOTPMutation();
  const [resendOTPApiReq, resendOTPApiRes] = useResendOTPMutation();
  const [verifyOTPApiReq, verifyOTPApiRes] = useVerifyOTPMutation();

  return {
    emailOtp,
    mobileOtp,
    resendOTPApiRes,
    resendOTPApiReq,
    sendOTPApiRes,
    sendOTPApiReq,
    verifyOTPApiRes,
    verifyOTPApiReq,
  };
};
